import React, {Component} from "react";
import {Badge} from "reactstrap";

export default class TransactionStatus extends Component {

    static getStatus(status) {

        let config = {
            CREATED: { color:"success", label: "Created" },
            ON_HOLD_UNPAID:{ color:"warning", label: "Pending"},
            APPROVED_UNPAID:{ color:"primary", label: "Unpaid"},
            APPROVED_PAID:{ color:"success", label: "Paid"},
            EXPIRED:{ color:"secondary", label: "Expired"},
            COMPLETE:{ color:"success", label: "Complete"},
            CANCELED:{ color:"secondary", label: "Canceled"},
            REJECTED:{ color:"secondary", label: "Canceled"},
            REFUNDED:{ color:"secondary", label: "Canceled"},
            MARKED_FOR_REFUND:{ color:"warning", label: "Pending Refund"},
            READY_FOR_REFUND:{ color:"warning", label: "Pending Refund"},
            MARKED_FOR_CANCELLATION:{ color:"warning", label: "Pending Cancellation"},
            READY_FOR_CANCELLATION:{ color:"warning", label: "Pending Cancellation"},
            REMITTANCE_BRAND_ON_HOLD:{ color:"warning", label: "Pending"},

            STAGED:{color:"warning", label: "Pending"},
            UNALLOCATED:{color:"warning", label: "Pending"},
            ALLOCATED_UNPAID:{color:"secondary", label: "Unpaid"},
            ALLOCATED_PENDING:{color:"warning", label: "Pending"},
            ALLOCATED_PAID:{color:"success", label: "Paid"},

            PENDING:{color:"secondary", label: "Pending"}
        };

        let statusConfig = config[status.toUpperCase()];
        return <Badge color={statusConfig.color} pill style={{paddingTop: "5px"}}>{statusConfig.label.toUpperCase()}</Badge>;
    }
}